import React from 'react';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { Button } from 'components/form/Button/Button';
import { Image } from 'components/Image/Image';
import Label from 'components/form/Label/Label';
import { BulletList, Bullet } from 'components/BulletList';
import OText from 'components/CText/OText';

const bullets = [
  'See if you pre-qualify in minutes',
  'No impact to your credit',
  'Get funds as soon as the next day*',
];
const PersonalLoanLowScoreModuleExpView = props => {
  return (
    <FlexContainer className="flex-container system_neutral_n000 grayShadow16 border-rad8px padTB26 padL32 padR44 m-padLR16">
      <FlexContainer
        className="format100 m-hide t-hide"
        justifyBetween
        alignItemsCenter
      >
        <FlexContainer justifyBetween alignItemsCenter>
          <FlexContainer className="dalign-items-start margT6 padR30">
            <Image className="personalLoanIconExp" />
          </FlexContainer>
          <FlexContainer className="flex-column">
            <FlexContainer justifyBetween alignItemsCenter>
              <FlexContainer className="flex-column">
                <Label
                  type="Body-2"
                  className="text-18 bold margt10 m-margt20 system_neutral_n400_text lineHeight140"
                >
                  Unexpected expenses? <div className="d-hide" /> A personal
                  loan can help
                </Label>
              </FlexContainer>
            </FlexContainer>
            <FlexContainer>
              <BulletList className="m-lineHeight-1-4 margT10 system_neutral_n400_text">
                {bullets.map((item, index) => {
                  return (
                    <Bullet className="text-14 margT4 block">
                      <OText text={item} />
                    </Bullet>
                  );
                })}
              </BulletList>
            </FlexContainer>
            <Label
              type="Body-2"
              className="text-10 m-text-10 system_neutral_n400_text m-text-center padR48"
            >
              *Application processing and approval times are determined by our
              partners. <br />
              See full offer terms and conditions to learn more.
            </Label>
          </FlexContainer>
        </FlexContainer>
        <FlexContainer
          className="align-self-center flex-row width250px"
          justifyCenter
          alignItemsCenter
        >
          <Button
            mrphType="primary"
            onClick={props.onClickPrequal}
            className="border-rad100px"
            fullWidth
          >
            <Label
              type="Subtitle-2"
              color="primary_cta_text_light"
              className="text-16 m-text-14"
              tabIndex="-1"
            >
              See If I’m Pre-Qualified
            </Label>
          </Button>
        </FlexContainer>
      </FlexContainer>
      <FlexContainer className="format100 d-hide" column alignItemsCenter>
        <FlexContainer justifyBetween alignItemsCenter className="format100">
          <FlexContainer
            className="flex-column"
            justifyBetween
            alignItemsCenter
          >
            <Label
              type="Body-2"
              className="text-16 bold system_neutral_n400_text lineHeight140"
            >
              Unexpected expenses? <div className="d-hide" /> A personal loan
              can help
            </Label>
          </FlexContainer>
          <FlexContainer className="dalign-items-start margT6" alignItemsCenter>
            <Image
              className="personalLoanIconExp"
              style={{ marginTop: '-20px' }}
            />
          </FlexContainer>
        </FlexContainer>
        <FlexContainer className="format100">
          <BulletList className="m-lineHeight-1-4 margT10 system_neutral_n400_text">
            {bullets.map((item, index) => {
              return (
                <Bullet className="text-14 margT4 block">
                  <OText text={item} />
                </Bullet>
              );
            })}
          </BulletList>
        </FlexContainer>
        <FlexContainer
          className="align-self-center flex-row format100"
          justifyCenter
          alignItemsCenter
        >
          <Button
            mrphType="primary"
            onClick={props.onClickPrequal}
            className="border-rad100px"
            fullWidth
          >
            <Label
              type="Subtitle-2"
              color="primary_cta_text_light"
              className="text-16 m-text-14"
              tabIndex="-1"
            >
              See If I’m Pre-Qualified
            </Label>
          </Button>
        </FlexContainer>
        <Label
          type="Body-2"
          className="text-10 system_neutral_n400_text margT16"
        >
          *Application processing and approval times are determined by our
          partners. See full offer terms and conditions to learn more.
        </Label>
      </FlexContainer>
    </FlexContainer>
  );
};

export default PersonalLoanLowScoreModuleExpView;
